import { Component, Input, type OnInit } from '@angular/core'
import { Attachment, AttachmentService } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-task-vendor-images',
  templateUrl: './task-vendor-images.component.html',
  styleUrls: ['./task-vendor-images.component.scss'],
})
export class TaskVendorImagesComponent implements OnInit {
  @Input() vendorImages: Attachment[] = []

  constructor(private attachmentService: AttachmentService) {}

  ngOnInit(): void {}

  onDownloadFile(item: Attachment) {
    this.attachmentService.downloadFile(item).subscribe()
  }
}
